export const environment = {
    githubDataEndpoint: 'https://us-central1-luizppa-com.cloudfunctions.net/calendar',
};
